import { HEX_ZOOM_THRESHOLDS } from "./config.js";

export function h3ResolutionForZoom(zoom) {
  const numericZoom = Number(zoom);
  if (!Number.isFinite(numericZoom) || numericZoom < HEX_ZOOM_THRESHOLDS.resolution4At) return 3;
  if (numericZoom < HEX_ZOOM_THRESHOLDS.resolution5At) return 4;
  if (numericZoom < HEX_ZOOM_THRESHOLDS.resolution6At) return 5;
  if (numericZoom < HEX_ZOOM_THRESHOLDS.resolution7At) return 6;
  return 7;
}
